import {
  Skeleton,
  StatCardSkeleton,
  SectionCardSkeleton,
  ChartSkeleton,
} from "@modootoday/ui-widgets";

export function PageFallbackSkeleton() {
  return (
    <div className="space-y-6">
      <div>
        <Skeleton className="h-7 w-48" />
        <Skeleton className="mt-2 h-4 w-80" />
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }, (_, i) => (
          <StatCardSkeleton key={i} />
        ))}
      </div>
      <SectionCardSkeleton>
        <ChartSkeleton height={200} />
      </SectionCardSkeleton>
    </div>
  );
}
